const entrega_material_escolar_por_aluno = [
  {
    path: "/entrega-material-escolar-por-aluno",
    redirect: "/entrega_material_escolar_por_aluno",
    meta: {
      breadCrumb: "Gestão - Material Escolar",
    },
    children: [
      {
        path: "/entrega-material-escolar-por-aluno",
        name: "entrega_material_escolar_por_aluno",
        component: () =>
          import(
            "@/views/EntregaMaterialEscolarPorAluno/EntregaMaterialEscolarPorAlunoHome.vue"
          ),
      },
      {
        path: "/entrega-material-escolar-por-aluno/novo",
        name: "entrega_material_escolar_por_aluno_novo",
        component: () =>
          import(
            "@/views/EntregaMaterialEscolarPorAluno/EntregaMaterialEscolarPorAlunoCadastro.vue"
          ),
      },
      {
        path: "/entrega-material-escolar-por-aluno/:id/editar",
        name: "entrega_material_escolar_por_aluno_editar",
        component: () =>
          import(
            "@/views/EntregaMaterialEscolarPorAluno/EntregaMaterialEscolarPorAlunoEditar.vue"
          ),
      },
    ],
  },
];

export { entrega_material_escolar_por_aluno };
